import { getServiceOrderList, placeOrder } from "../../Services/MainServices";
import { toast } from "react-toastify";

export const PLACE_ORDER_REQUEST = "PLACE_ORDER_REQUEST";
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAILURE = "PLACE_ORDER_FAILURE";

export const GET_ORDER_REQUEST = "GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_FAILURE = "GET_ORDER_FAILURE";

export const placeNewOrder = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PLACE_ORDER_REQUEST });
    const response = await placeOrder(payload); // Call your order placement API
    // console.log("Updated formData:", JSON.stringify(response, null, 2));

    if (response?.data.status === "success") {
      dispatch({
        type: PLACE_ORDER_SUCCESS,
        payload: response.data, // e.g., order ID, order summary, etc.
      });
      return response?.data;
    } else {
      dispatch({
        type: PLACE_ORDER_FAILURE,
        error: response.message || "Failed to place order",
      });
      toast.success(response?.data?.message);
    }
  } catch (error) {
    dispatch({
      type: PLACE_ORDER_FAILURE,
      error: error.message || "Something went wrong",
    });
  }
};

export const getOrderList = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GET_ORDER_REQUEST });
    const response = await getServiceOrderList(payload); // Call your order placement API
    // console.log("Order List Response:", response);
    if (response?.data?.status == "success") {
      dispatch({
        type: GET_ORDER_SUCCESS,
        payload: response?.data?.data, // array of user orders
      });
    } else {
      dispatch({
        type: GET_ORDER_FAILURE,
        error: response?.data.message || "Failed to place order",
      });
    }
  } catch (error) {
    dispatch({
      type: GET_ORDER_FAILURE,
      error: error.message || "Something went wrong",
    });
  }
};
